// ColumnFilter.tsx
import {
  Group,
  Stack,
  Menu,
  TextInput,
  ActionIcon,
  Tooltip,
  Button,
} from "@mantine/core";
import { Column } from "@tanstack/react-table";
import React, { useState } from "react";
import styles from "@scss/custom-components/sort-and-filter.module.scss";

interface ColumnButtonProps {
  column: Column<any, any>;
}

export const CustomColumnFilter: React.FC<ColumnButtonProps> = ({ column }) => {
  const [state, setState] = useState<null | { value: any }>(null);

  if (!column.getCanFilter()) return null;

  const open = () => setState({ value: column.getFilterValue() });
  const close = () => setState(null);
  const change = (value: any) => setState({ value });
  const clear = () => {
    column.setFilterValue(undefined);
    close();
  };
  const save = () => {
    if (!state) return;
    column.setFilterValue(state.value);
    close();
  };

  const FilterComponent = (column.columnDef?.meta as any)?.filterElement;

  const renderFilterElement = () => {
    if (!FilterComponent && state) {
      return (
        <TextInput
          variant="darker"
          placeholder="Filter..."
          autoComplete="off"
          value={state.value ?? ""}
          onChange={(e) => change(e.target.value)}
        />
      );
    }
    return <FilterComponent value={state?.value} onChange={change} />;
  };

  const buttonClass = [
    styles.filterButton,
    column.getIsFiltered() ? styles["filterButton--filtered"] : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <Menu
      opened={!!state}
      position="bottom"
      shadow="xl"
      onClose={close}
      width="256px"
      withinPortal
    >
      <Menu.Target>
        <ActionIcon size="xs" onClick={open} className={buttonClass}>
          <></>
        </ActionIcon>
      </Menu.Target>

      <Menu.Dropdown>
        {!!state && (
          <Stack p="xs" gap="xs">
            {renderFilterElement()}
            <Group align="right" gap={12}>
              <Tooltip label="Clear filter" position="bottom">
                <Button variant="carrot-icon" onClick={clear} size="xs">
                  <></>
                </Button>
              </Tooltip>
              <Tooltip label="Apply filter" position="bottom">
                <Button variant="primary-icon" onClick={save} size="xs">
                  <></>
                </Button>
              </Tooltip>
            </Group>
          </Stack>
        )}
      </Menu.Dropdown>
    </Menu>
  );
};
